import { useGetModulesConfigQuery } from './queries/useGetModulesConfigQuery'

export function useConfigClientModuleManager() {
  const { data } = useGetModulesConfigQuery()

  const activeModules = data || []

  const checkPermissionModulesAndReturn = <T>(
    module: string,
    toReturn: T
  ): T[] => {
    const isModuleActive = activeModules.some(
      (activeModule) => activeModule.module === module
    )
    return isModuleActive ? [toReturn] : []
  }

  return {
    checkPermissionModulesAndReturn
  }
}
